import { createRoot } from "react-dom/client";
import { createHashRouter, RouterProvider } from "react-router-dom";
import TopupPage from "./pages/topup";
import BiodataPage from "./pages/biodata";
import FindMatePage from "./pages/cariPasangan";
import TaarufPage from "./pages/taaruf";
import SettingsPage from "./pages/settings";
import BonusPage from "./pages/bonus";

export default function runAccount() {
  const el = document.getElementById("sakinahAccount");
  if (!el) return;

  const rootAccount = createRoot(el);
  rootAccount.render(<App />);
}

const router = createHashRouter([
  {
    path: "/",
    element: <TopupPage />,
  },
  {
    path: "/biodata",
    element: <BiodataPage />,
  },
  {
    path: "/cari-pasangan",
    element: <FindMatePage />,
  },
  {
    path: "/taaruf",
    element: <TaarufPage />,
  },
  {
    path: "/settings",
    element: <SettingsPage />,
  },
  {
    path: "/bonus",
    element: <BonusPage />,
  },
]);

function App() {
  return <RouterProvider router={router} />;
}
